export default __webpack_public_path__ + "static/media/FOR-BUSD.b99baae9.svg";